<template>
    <div class="gas-curve">
        <div class="menu-wrap">
            <el-form :inline="true" >
                <el-form-item label="开始时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="start_date"
                    type="date"
                    class="start_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="start_time"
                    class="start_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>
        
                <el-form-item label="结束时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="end_date"
                    type="date"
                    class="end_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="end_time"
                    class="end_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>

                <el-form-item label="选择预设时间">
                    <el-select placeholder="预设时间" v-model="time_range" class="time_range" @change="timeRangeChange">
                        <el-option label="自定义" value="customize"></el-option>
                        <el-option label="最近一天" value="day"></el-option>
                        <el-option label="最近一周" value="week"></el-option>
                        <el-option label="最近一月" value="month"></el-option>
                        <el-option label="最近一年" value="year"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-button plain type="primary" class="menu-btn" @click="searchData()">
                    查询
                </el-button>

                <el-button plain type="primary" class="menu-btn" @click="showSitesSelect">
                    站点筛选
                </el-button>

                <!--数据导出-->
                <!-- <download-excel 
                    class = "export-excel-wrapper"
                    :data = "pricelist"
                    :before-generate="exportFile"
                    :fields = "priceFileds"
                    :header="priceHeader"
                    :name = "priceFileName">
                    <el-button plain type="primary" class="menu-btn">
                        导出
                    </el-button>
                </download-excel> -->
            </el-form>
            
        </div>


        <!-- 站点筛选--dialog -->
        <siteselect :show.sync="sitesDialog" v-on:siteSelectCompleted="siteSelectCompleted"></siteselect>
    </div>
</template>

<script>
export default {
    name:"gastable",
    data(){
        return {
            start_date:'', //开始日期
            end_date:'', // 结束日期
            start_time:'', // 开始时间
            end_time:'', // 结束时间
            time_range:"day", // 时间范围下拉框
            sitesDialog:false, // 站点筛选对话框

            datapage:{
                current:1,
                size:10,
                total:0,
            }, // 分页信息


        }
    },
    components:{
        siteselect: ()=>import("@components/SiteSelect"), // 站点筛选
    },
    methods:{
        // 获取数据
        getDataList(){

        },
        // 时间范围事件
        timeRangeChange(val){
            // 获取当前时间
            let nowTime=this.$moment();
            let startTime=nowTime;

            // 格式化结束日期和时间
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间
            switch (val){
                case "day":
                startTime=nowTime.add(-1,'day');
                break;
                case "week":
                startTime=nowTime.add(-1,'week');
                break;
                case "month":
                startTime=nowTime.add(-1,'month');
                break;
                case "year":
                startTime=nowTime.add(-1,'year');
                break;
                default:
                startTime=nowTime.add(-1,'day');
                break;
            }
            this.start_date= startTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=startTime.format('HH:mm'); // 开始时间
        },
        // 时间改变
        timeChange(){
            this.time_range="customize"; // 改为自定义
        },
        //站点选择完成之后
        siteSelectCompleted(selectedSites) {
            // 更新选中的站点数据
            // this.getSelectedSites(selectedSites);
        },
        // 查询数据
        searchData(){
            this.getDataList("","","",1,this.datapage.size);
        },
        // 显示站点筛选
        showSitesSelect(){
            this.sitesDialog=true;
        },

        // 每页条数改变
        handleSizeChange(val){
            this.getDataList("","","",1,val);
        },
        // 页码改变
        handleCurrentChange(val){
            this.getDataList("","","",val,this.rechargepage.size);
        },
        
    }
}
</script>

<style lang="scss" scoped>
/**菜单栏 */
.menu-wrap{
    background: #fff;
    padding:10px;

    /**菜单栏按钮 */
    .menu-btn {
        height: 40px;
        margin-right: 5px;
        padding: 12px;
        margin-left: 5px;

        span {
            font-size: 16px;
            font-weight: 400;
            cursor: pointer;
        }
    }

    .date-input{
        width:135px;
        ::v-deep  input {
            width:130px;
            padding-right: 15px;
        }
    }

    .time-input{
        width:100px;

        ::v-deep input {
            width:90px;
            padding-right: 10px;
        }
    }
    /**时间范围 */
    ::v-deep .time_range{
        width:120px;
    }

    .el-form-item{
        margin-bottom: initial;
    }

    .export-excel-wrapper{
        display: inline-block;
    }

    .el-radio-button__inner{
        padding:12px;
    }
}
</style>